module.exports = __webpack_public_path__ + "img/DIPLOMA-MARCELO.f046463c.png";